// extracted by mini-css-extract-plugin
export default {"content":"menuEntryListContainer_content__zrD3I","newMenuEntryButton":"menuEntryListContainer_newMenuEntryButton__5UufR"};